import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { QUALITY_CHECK, QUALITY_CHECK_COLORS } from '../../config/const.config';

const QualityStatusLabel = ({ value }) => {
  const label = QUALITY_CHECK[value] || 'Not Checked';
  const color = QUALITY_CHECK_COLORS[value] || 'warning';

  return (
    <Chip
      label={label}
      color={color}
      variant="filled"
      size="small"
      sx={{ fontWeight: 500, fontSize: 10, height: 18 }}
    />
  );
};

QualityStatusLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default QualityStatusLabel;
